export default __webpack_public_path__ + "static/media/Mysql.0d598ae4.png";